import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { config } from 'app/app.config';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AssistBotService {

  searchListBheaviour:BehaviorSubject<any> = new BehaviorSubject([]);
  baseUrl = `${config.PROTOCOL}://${config.HOST}:${config.PORT}/canstring/${config.VERSION}`;
  chatHistoryList:any=[];
  chatPinList:any=[];
  chatbotData:any=[];
  chatbotDocFiles:any=[];
  chatbotAudioFiles:any=[];
  ChatCommentsList:any=[];
  historyListBheaviour:BehaviorSubject<any> = new BehaviorSubject({});
  GptConfiguration:any;
  tabPanelBheaviour:BehaviorSubject<any> = new BehaviorSubject({});
  queryType:any={};
  seletedClass:any=[];
  constructor(
    private http: HttpClient
  ) { }

  createHistory(payload){
    return this.http.post(`${this.baseUrl}/createHistory`, payload);
  }

  getChatBotHistory(){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.get(`${this.baseUrl}/getChatBotHistory?user_id=${user_id}`);
  }

  deleteHistory(historyNo){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.delete(`${this.baseUrl}/deleteHistory/${historyNo}/${user_id}`);
  }

  updateAIBotHistory(historyNo:any, payload:any){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.put(`${this.baseUrl}/updateChatBotHistory/${historyNo}/${user_id}`, payload)
  }

  deletePin(pinNo){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.delete(`${this.baseUrl}/deletePin/${pinNo}/${user_id}`);
  }

  deleteDoc(docNo){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.delete(`${this.baseUrl}/deleteDoc/${docNo}/${user_id}`);
  }

  deleteAudio(audioNo){
    let user_id = window.localStorage.getItem('user_id');
    return this.http.delete(`${this.baseUrl}/deletePin/${audioNo}/${user_id}`);
  }

  deleteAllHistoryLists(){
    let user_id = window.localStorage.getItem('user_id');
    let payload={
      "user_id":user_id,
      "question_type":"history"
    }
    return this.http.delete(`${this.baseUrl}/deleteHistory/deleteAllHistoryLists/${payload}`);
  }

  deleteAllPinList(){
    let user_id = window.localStorage.getItem('user_id');
    let payload={
      "user_id":user_id,
      "question_type":"pin"
    }
    return this.http.delete(`${this.baseUrl}/deleteHistory/deleteAllHistoryLists/${payload}`);
  }


 getClientConfig(){
    return this.http.get('../assets/json/client_config.json');
 }

  BotFilegenerate(payload:any){
    return this.http.post(`${this.baseUrl}/addBotLessonandAudio`,payload)
  }

  RefreshBotData(payload:any,params:any){
    return this.http.put(`${this.baseUrl}/updateChatBotHistory/${params['history_id']}/${params['user_id']}`,payload);
  }

  getllmfile(llmfile_uuid:any){
      return this.http.get(`${this.baseUrl}`+'/chats/uniqsecureReadfile/'+llmfile_uuid,{ responseType: 'blob' });
   }

   createComments(payload:any){
     return this.http.post(`${this.baseUrl}/createAIFeedback`,payload);
   }

   getComments(){
    return this.http.get(`${this.baseUrl}/getComments`);
   }


   getBotHistory(offset:number,limit:number){
   let user_id = localStorage.getItem("user_id");
    return this.http.get(`${this.baseUrl}/bot-history/${user_id}?offset=${offset}&limit=${limit}`);
   }

    getBotPin(offset:number,limit:number){
   let user_id = localStorage.getItem("user_id");
    return this.http.get(`${this.baseUrl}/bot-pin/${user_id}?offset=${offset}&limit=${limit}`);
   }

    getBotDocument(offset:number,limit:number){
   let user_id = localStorage.getItem("user_id");
    return this.http.get(`${this.baseUrl}/bot-doc/${user_id}?offset=${offset}&limit=${limit}`);
   }

    getBotAudio(offset:number,limit:number){
      let user_id = localStorage.getItem("user_id");
    return this.http.get(`${this.baseUrl}/bot-audio/${user_id}?offset=${offset}&limit=${limit}`);
   }


}
